export const APP_ROUTES = {
	login: "/login",
	instances: ["/", "/home"],
	instance: ["/instance/:instanceId", "/instance/:instanceId/general"],
	instancePayments: "/instance/:instanceId/payments",
	instanceBilling: "/instance/:instanceId/billing",
	customInvoiceForm: "/generate-invoice",
};